// Les codes de SLOT sont un sur-ensemble des codes de JOUEUR.
//
// Un joueur reste fiché `DD` ; le slot `PD` d'un 3-4-2-1 demande un piston, et c'est
// la matrice qui fait le pont (DD→PD = 1.8). Zéro saisie supplémentaire, expressivité
// complète. Un joueur qui joue VRAIMENT piston peut le déclarer dans `alt` et passe
// alors devant les latéraux convertis.
const POSTES_JOUEUR = ['GB', 'DC', 'DD', 'DG', 'MDC', 'MC', 'MOC', 'AID', 'AIG', 'BU'];
export const POSTES_SLOT = [...POSTES_JOUEUR, 'PD', 'PG', 'MD', 'MG'];

export const LIBELLE = {
  GB: 'Gardien',
  DC: 'Défenseur central',
  DD: 'Latéral droit',
  DG: 'Latéral gauche',
  PD: 'Piston droit',
  PG: 'Piston gauche',
  MDC: 'Milieu défensif',
  MC: 'Milieu central',
  MD: 'Milieu droit',
  MG: 'Milieu gauche',
  MOC: 'Milieu offensif',
  AID: 'Ailier droit',
  AIG: 'Ailier gauche',
  BU: 'Buteur',
};

// Les quatre lignes, pour les filtres de l'écran Effectif et le groupement des listes.
export const LIGNE = {
  GB: 'Gardiens',
  DC: 'Défense', DD: 'Défense', DG: 'Défense', PD: 'Défense', PG: 'Défense',
  MDC: 'Milieu', MC: 'Milieu', MD: 'Milieu', MG: 'Milieu', MOC: 'Milieu',
  AID: 'Attaque', AIG: 'Attaque', BU: 'Attaque',
};
export const LIGNES = ['Gardiens', 'Défense', 'Milieu', 'Attaque'];

/**
 * LA MATRICE D'ADÉQUATION. Ligne = poste réel du joueur, colonne = slot demandé.
 *
 * Un modèle binaire (2 si c'est son poste, 1 si c'est dans ses postes secondaires) ne
 * suffit pas, et le contre-exemple est net : un MC qui dépanne MDC perd cinq pour cent
 * de son rendement, un DC qui dépanne DD en perd la moitié — il ne monte pas, il ne
 * centre pas, il défend en reculant sur un ailier. Les noter tous deux « 1 » fait
 * remonter le défenseur central au même rang que le milieu dans la feuille « Qui joue
 * ici ? », c'est-à-dire exactement au moment où l'application doit être juste.
 */
export const ADEQUATION = {
  GB:  { GB: 2.0, DC: 0,   DD: 0,   DG: 0,   PD: 0,   PG: 0,   MDC: 0,   MC: 0,   MD: 0,   MG: 0,   MOC: 0,   AID: 0,   AIG: 0,   BU: 0 },
  DC:  { GB: 0,   DC: 2.0, DD: 1.0, DG: 1.0, PD: 0.5, PG: 0.5, MDC: 1.3, MC: 0.4, MD: 0.2, MG: 0.2, MOC: 0,   AID: 0,   AIG: 0,   BU: 0.3 },
  DD:  { GB: 0,   DC: 1.3, DD: 2.0, DG: 1.2, PD: 1.8, PG: 1.0, MDC: 0.6, MC: 0.6, MD: 1.5, MG: 0.8, MOC: 0.2, AID: 1.2, AIG: 0.5, BU: 0 },
  DG:  { GB: 0,   DC: 1.3, DD: 1.2, DG: 2.0, PD: 1.0, PG: 1.8, MDC: 0.6, MC: 0.6, MD: 0.8, MG: 1.5, MOC: 0.2, AID: 0.5, AIG: 1.2, BU: 0 },
  PD:  { GB: 0,   DC: 0.8, DD: 1.8, DG: 1.1, PD: 2.0, PG: 1.1, MDC: 0.4, MC: 0.5, MD: 1.7, MG: 1.0, MOC: 0.3, AID: 1.4, AIG: 0.6, BU: 0 },
  PG:  { GB: 0,   DC: 0.8, DD: 1.1, DG: 1.8, PD: 1.1, PG: 2.0, MDC: 0.4, MC: 0.5, MD: 1.0, MG: 1.7, MOC: 0.3, AID: 0.6, AIG: 1.4, BU: 0 },
  MDC: { GB: 0,   DC: 1.4, DD: 0.7, DG: 0.7, PD: 0.4, PG: 0.4, MDC: 2.0, MC: 1.8, MD: 0.6, MG: 0.6, MOC: 0.8, AID: 0.2, AIG: 0.2, BU: 0 },
  MC:  { GB: 0,   DC: 0.5, DD: 0.7, DG: 0.7, PD: 0.8, PG: 0.8, MDC: 1.7, MC: 2.0, MD: 1.2, MG: 1.2, MOC: 1.6, AID: 0.7, AIG: 0.7, BU: 0.4 },
  MD:  { GB: 0,   DC: 0.2, DD: 1.4, DG: 0.9, PD: 1.6, PG: 1.0, MDC: 0.7, MC: 1.3, MD: 2.0, MG: 1.2, MOC: 1.1, AID: 1.7, AIG: 1.0, BU: 0.4 },
  MG:  { GB: 0,   DC: 0.2, DD: 0.9, DG: 1.4, PD: 1.0, PG: 1.6, MDC: 0.7, MC: 1.3, MD: 1.2, MG: 2.0, MOC: 1.1, AID: 1.0, AIG: 1.7, BU: 0.4 },
  MOC: { GB: 0,   DC: 0,   DD: 0.2, DG: 0.2, PD: 0.3, PG: 0.3, MDC: 0.9, MC: 1.6, MD: 1.3, MG: 1.3, MOC: 2.0, AID: 1.4, AIG: 1.4, BU: 1.4 },
  AID: { GB: 0,   DC: 0,   DD: 0.7, DG: 0.4, PD: 1.1, PG: 0.7, MDC: 0.3, MC: 0.8, MD: 1.6, MG: 1.2, MOC: 1.4, AID: 2.0, AIG: 1.5, BU: 1.2 },
  AIG: { GB: 0,   DC: 0,   DD: 0.4, DG: 0.7, PD: 0.7, PG: 1.1, MDC: 0.3, MC: 0.8, MD: 1.2, MG: 1.6, MOC: 1.4, AID: 1.5, AIG: 2.0, BU: 1.2 },
  BU:  { GB: 0,   DC: 0,   DD: 0,   DG: 0,   PD: 0,   PG: 0,   MDC: 0.2, MC: 0.5, MD: 0.7, MG: 0.7, MOC: 1.4, AID: 1.2, AIG: 1.2, BU: 2.0 },
};

// Les paliers de la feuille « Qui joue ici ? ». Les indisponibles n'y figurent pas du
// tout — ils ne sont pas grisés : à vingt secondes, debout, dans le bruit, on ne lit
// pas du gris, on lit des noms.
export const PALIERS = [
  { min: 1.8, titre: 'À son poste', replie: false },
  { min: 1.2, titre: 'Peut le faire', replie: false },
  { min: 0.6, titre: 'Dépannage', replie: true },
];

export const STATUTS = {
  ok: { libelle: 'Disponible', ton: 'bon' },
  doute: { libelle: 'Incertain', ton: 'attention' },
  blesse: { libelle: 'Blessé', ton: 'mauvais' },
  susp: { libelle: 'Suspendu', ton: 'mauvais' },
};

export const estDisponible = (j) => j?.statut !== 'blesse' && j?.statut !== 'susp';
